import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import pt from 'vuetify/lib/locale/pt';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt',
  },

  icons: {
    iconfont: 'mdi',
  },

  theme: {
    dark: false,
    themes: {
      light: {
        background: '#FFFFFF',
        surface: '#FFFFFF',
        primary: '#20B1AC',
        secondary: '#0F4C4A',
        accent: '#0F4C4A',
        error: '#B00020',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
      },
      dark: {
        primary: '#20B1AC',
        secondary: '#0F4C4A',
        success: '#4CAF50',
        info: '#2196F3',
        warning: '#FB8C00',
        error: '#FF7043',
      },
    },
  },
});
